import * as i0 from '@angular/core';
import { HostListener, Input, Component } from '@angular/core';
const _c0 = ["*"];
let ModalOffcanvasTriggerComponent = /*#__PURE__*/(() => {
  class ModalOffcanvasTriggerComponent {
    constructor() {
      this.targetId = '';
      this.backdropId = 'modalBackdrop';
    }
    onClick() {
      this.showOffCanvas();
      this.showBackdrop();
    }
    showOffCanvas() {
      const target = document.getElementById(this.targetId);
      if (!target) {
        return;
      }
      target.classList.add('show');
    }
    showBackdrop() {
      const backdrop = document.getElementById(this.backdropId);
      if (!backdrop) {
        return;
      }
      backdrop.classList.add('show');
    }
    static {
      this.ɵfac = function ModalOffcanvasTriggerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalOffcanvasTriggerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalOffcanvasTriggerComponent,
        selectors: [["ui-modal-offcanvas-trigger"]],
        hostBindings: function ModalOffcanvasTriggerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ModalOffcanvasTriggerComponent_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          targetId: "targetId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function ModalOffcanvasTriggerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return ModalOffcanvasTriggerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ModalOffcanvasTriggerComponent };
